import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: #14162F;
  color: white;
  padding: 4rem 2rem;
`;

const FooterInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 2rem;
  }
`;

const BrandSection = styled.div``;

const BrandName = styled.h3`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
`;

const BrandDescription = styled.p`
  color: #9CA3AF;
  font-size: 0.95rem;
  max-width: 300px;
`;

const FooterSection = styled.div``;

const SectionTitle = styled.h4`
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 1.25rem;
`;

const LinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const FooterLink = styled(Link)`
  color: #9CA3AF;
  text-decoration: none;
  font-size: 0.9rem;
  
  &:hover {
    color: white;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
`;

const SocialIcon = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: transparent;
  border-radius: 50%;
  color: white;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

const NewsletterSection = styled.div``;

const NewsletterText = styled.p`
  color: #9CA3AF;
  margin-bottom: 1rem;
  font-size: 0.95rem;
`;

const SubscribeForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 300px;
`;

const EmailInput = styled.input`
  padding: 0.75rem;
  border: 1px solid #374151;
  background-color: transparent;
  border-radius: 4px;
  color: white;
`;

const SubscribeButton = styled.button`
  padding: 0.75rem;
  background-color: white;
  color: #14162F;
  font-weight: 600;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  
  &:hover {
    background-color: #f3f4f6;
  }
`;

const BottomSection = styled.div`
  margin-top: 3rem;
  padding-top: 1.5rem;
  border-top: 1px solid #374151;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Copyright = styled.p`
  color: #9CA3AF;
  font-size: 0.875rem;
`;

const LegalLinks = styled.div`
  display: flex;
  gap: 1.5rem;
`;

const LegalLink = styled(Link)`
  color: #9CA3AF;
  text-decoration: none;
  font-size: 0.875rem;
  
  &:hover {
    color: white;
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterInner>
        <BrandSection>
          <BrandName>Wonder</BrandName>
          <BrandDescription>
            Empowering individuals to take control of their health through data-driven nutrition and personalized coaching.
          </BrandDescription>
          <SocialIcons>
            <SocialIcon to="#">
              <i className="fab fa-facebook-f"></i>
            </SocialIcon>
            <SocialIcon to="#">
              <i className="fab fa-instagram"></i>
            </SocialIcon>
            <SocialIcon to="#">
              <i className="fab fa-twitter"></i>
            </SocialIcon>
          </SocialIcons>
        </BrandSection>
        
        <FooterSection>
          <SectionTitle>Quick Links</SectionTitle>
          <LinkList>
            <li><FooterLink to="/our-story">Our Story</FooterLink></li>
            <li><FooterLink to="/shop">Shop</FooterLink></li>
            <li><FooterLink to="/nutritionists">Wonder Kliniker</FooterLink></li>
            <li><FooterLink to="/journal">Journal</FooterLink></li>
            <li><FooterLink to="/our-experts">Om Wonder teknologin</FooterLink></li>
          </LinkList>
        </FooterSection>
        
        <FooterSection>
          <SectionTitle>Customer Support</SectionTitle>
          <LinkList>
            <li><FooterLink to="/contact">Contact Us</FooterLink></li>
            <li><FooterLink to="/help">Help Center</FooterLink></li>
            <li><FooterLink to="/become-nutritionist">Bli en Wonder Klinik</FooterLink></li>
            <li><FooterLink to="/admin">Admin Login</FooterLink></li>
            <li><FooterLink to="/dashboard">Customer Dashboard</FooterLink></li>
          </LinkList>
        </FooterSection>
        
        <NewsletterSection>
          <SectionTitle>Stay Updated</SectionTitle>
          <NewsletterText>
            Subscribe to our newsletter for the latest health tips and updates.
          </NewsletterText>
          <SubscribeForm>
            <EmailInput type="email" placeholder="Your email" />
            <SubscribeButton type="submit">Subscribe</SubscribeButton>
          </SubscribeForm>
        </NewsletterSection>
      </FooterInner>
      
      <BottomSection>
        <Copyright>© 2025 Wonder Health. All rights reserved.</Copyright>
        <LegalLinks>
          <LegalLink to="/privacy">Privacy Policy</LegalLink>
          <LegalLink to="/terms">Terms of Service</LegalLink>
          <LegalLink to="/cookies">Cookie Policy</LegalLink>
        </LegalLinks>
      </BottomSection>
    </FooterContainer>
  );
};

export default Footer; 